import LoginForm from "components/LoginForm";
import ResetPasswordForm from "components/ResetPasswordForm";
import SignupForm from "components/SignupForm";
import { Images } from "constants/Images";
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "stylesheets/login.scss";

const tabs = [
  {
    id: 1,
    title: "Login",
  },
  {
    id: 2,
    title: "Signup",
  },
];

const LoginSignupPage = (props) => {
  const [currentTab, setCurrentTab] = useState(1);
  const location = useLocation();



  const [forgot, setForgot] = useState(false);

  // useEffect(() => {
  //   setCurrentTab(1);
  // }, []);


  useEffect(() => {
    if (location.state && location.state.formType) {
      if (location.state.formType === "login") {
        setCurrentTab(1);
      } else if (location.state.formType === "signup") {
        setCurrentTab(2);
      }
    } else {
      setCurrentTab(1);
    }
  }, [location.state]);

  const onTab = (id) => {
    setCurrentTab((prevID) => {
      if (prevID !== id) return id;
      return id;
    });
  };
  const SetTo1 = () => {
    setCurrentTab(1);
  };
  const onForgot = () => {
    setForgot(!forgot);
  };

  const toLogin = () => {
    setForgot(false);
  };

  return (
    <section className="login">
      <div className="row no-gutters">
        <div className="login__img">
          <img src="/images/login-bg.png" alt="" />
          <div class="login__img_txt">
            <h2 className="login__img__ttl">MIFAB Drainage Solutions</h2>
            <div className="login__img__des">
              <p>
                Finding the right drainage and plumbing solutions can be
                complex...until now.
              </p>
            </div>
          </div>
        </div>
        <div className="login__form">
          <div className="login__form__cover">
            <div className="login__form__logo">
              <Link to="/">
                <img src="/images/logo.png" alt="" />
              </Link>
            </div>
            <div className="login__title">
              {forgot ? (
                <>
                  <h2>Reset Password</h2>
                  <p>
                    Enter your Sign In email address so we can send you steps on
                    how to reset your password.
                  </p>
                </>
              ) : (
                <>
                  {currentTab === 1 && (
                    <>
                      <h2>Welcome to Mifab</h2>
                      <p>
                        Please enter your email address and password to login.
                      </p>
                    </>
                  )}
                  {currentTab === 2 && <h2>Create Account</h2>}
                </>
              )}
            </div>
            <div className="tabs">
              {forgot ? null : (
                <div className="tab">
                  <ul>
                    {tabs.map((item) => (
                      <li
                        key={item.id}
                        onClick={() => onTab(item.id)}
                        className={item.id === currentTab ? "active" : ""}
                      >
                        {item.title}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              <div className="content">
                {forgot ? (
                  <div className="loginTab">
                    <ResetPasswordForm toLogin={toLogin} />
                  </div>
                ) : (
                  <>
                    {currentTab === 1 && (
                      <div className="loginTab">
                        <LoginForm forgot={onForgot} click={props.login} />
                      </div>
                    )}
                    {currentTab === 2 && (
                      <div className="signupTab">
                        <SignupForm onTab1={SetTo1} click={props.login} />
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default LoginSignupPage;
